<div
  class="avatar-wrapper"
  [style.background-color]="computedBackgroundColor()"
  [style.background-image]="computedBackgroundImageUrl()"
>
  @if (!computedBackgroundImageUrl()) {
    @if (svgIcon()) {
      <mat-icon [inline]="true" [svgIcon]="svgIcon()" />
    } @else if (icon()) {
      <mat-icon [inline]="true" class="avatar-mat-icon">{{ icon() }}</mat-icon>
    } @else if (computedAbbreviation()) {
      <span>{{ computedAbbreviation() }}</span>
    } @else {
      <mat-icon [inline]="true" class="avatar-mat-icon">{{ defaultIcon }}</mat-icon>
    }
  }
</div>
